import AssignmentIndRoundedIcon from "@mui/icons-material/AssignmentIndRounded";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import CoreTable from "../../../app/core/components/CoreTable/CoreTable";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables";
import { useGetCommercialistaQuery } from "../../api/admin/gestisciCommercialistiApi";
import { doReportOperator } from "./gestisciUtentiSlice";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import GestisciStudioFilter from "../../business/GestisciStudioPage/GestisciStudioFilter";
import { useGetStudiosQuery } from "../../api/admin/gestisciStudioApi";
import CoreChip from "../../../app/core/components/CoreChip/CoreChip";
import { labelForFilterOperators } from "../../../utils/functions/filters";
import UserFilter from "../../../app/core/components/UserFilter/UserFilter";
import { useTranslation } from "react-i18next";
import { ROLE } from "../../../utils/constants/profiles";
import { useGetRolesQuery } from "../../api/admin/rolesApi";

const GestisciCommercialistiPage = () => {
  const { t } = useTranslation();
  const appConfig = useSelector((state) => state.app.appConfig);
  const role = useSelector((state) => state.app.role);
  const columns = [
    t("Name"),
    t("Surname"),
    "Email",
    t("Role"),
    t("OperatorType"),
    t("StudioLocation"),
  ].filter(
    (e) =>
      e !== t("OperatorType") || appConfig?.modules?.studio?.adminProfileRoles
  );
  const [rows, setRows] = useState([]);
  const [user, setUser] = useState();
  const [debouncedInputUserValue, setDebouncedInputUserValue] = useState("");
  const [debouncedInputStudioValue, setDebouncedInputStudioValue] =
    useState("");

  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });
  const [filter, setFilter] = useState({
    identityRoleId: "",
    studioId: "",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data, error, isLoading, isFetching, refetch } =
    useGetCommercialistaQuery({
      page,
      value: debouncedInputUserValue,
      filter,
    });

  const { data: rolesData } = useGetRolesQuery(filter);

  const { data: adminStudio } = useGetStudiosQuery({
    ...{ currentPage: 1, startRow: 0, endRow: 5 },
    value: debouncedInputStudioValue,
  });
  useEffect(() => {
    const isValidation = data && data?.Data && data?.Data?.items;
    if (isValidation) {
      // tutti i dati degli utenti
      const userData = data?.Data?.items.map((el) => ({
        Id: el.id,
        [t("Name")]: el.name,
        [t("Surname")]: el.surname,
        Email: el.email,
        [t("Role")]:
          el.subRole === "Consulente" ? t("subRoleAdmin") : el.subRole,
        ...(appConfig?.modules?.studio?.adminProfileRoles && {
          [t("OperatorType")]: el?.adminProfileRoles[0]?.identityRole?.name,
        }),
        [t("StudioLocation")]: el.studioName,
      }));
      // Dati della tabella
      setRows(userData);
    }
  }, [data, t, appConfig?.modules?.studio?.adminProfileRoles]);

  const handleOpen = (Id) => {
    setUser(Id);
  };

  const handleDownload = () => {
    toast.info("Il report è in fase di download");
    dispatch(doReportOperator());
  };

  const actions = [
    {
      icon: <AssignmentIndRoundedIcon />,
      onClick: handleOpen,
      tooltip: t("Card") + " " + t("Operator"),
    },
  ];

  useEffect(() => {
    if (user?.Id) navigate(`${user?.Id}`);
  }, [user?.Id, navigate]);

  const handleRefecthDocuments = () => {
    refetch();
  };

  const handleRemoveFilter = (f) => {
    let newFilter = { ...filter };
    Object.entries(newFilter).forEach(([k, v]) => {
      if (v === f) newFilter[k] = "";
    });
    setFilter(newFilter);
  };

  if (isLoading) {
    return <CoreSpinner />;
  }

  return (
    <>
      <div className="flex flex-col">
        <h2 className="font-bold">{t("Operators")}</h2>
        <div className="flex flex-row -mt-16 justify-end space-x-2">
          {Object.entries(filter).map(
            ([k, v]) =>
              v !== "" && (
                <CoreChip
                  key={v}
                  label={labelForFilterOperators(k, v, rolesData, adminStudio)}
                  variant="outlined"
                  onDelete={() => handleRemoveFilter(v)}
                />
              )
          )}
          {(appConfig?.modules?.studio?.adminProfileRoles ||
            role === ROLE.ADMIN) && (
            <div>
              <GestisciStudioFilter
                rolesData={rolesData?.Data}
                filter={filter}
                setFilter={setFilter}
                studios={adminStudio}
                setDebouncedInputStudioValue={setDebouncedInputStudioValue}
              />
            </div>
          )}
        </div>

        <div className="flex flex-row justify-between mt-10 ">
          <div className="w-4/12">
            <UserFilter
              selectedUser={user}
              setSelectedUser={setUser}
              usersList={data?.Data?.items}
              setDebouncedInputUserValue={setDebouncedInputUserValue}
              isUsersLoading={isLoading}
              setPage={setPage}
              externalLabel={`${t("BriefSearchOperator")}`}
              externalPlaceholder={`${t("ExtSearchOperator")}`}
              externalNegativeLabel={t("NoOperatorFound")}
            />
          </div>
          <div className="w-8/12">
            <CoreButtonHoverIcon
              onClick={handleRefecthDocuments}
              className="text-blue-500 m-1 flex flex-row space-x-2 border"
              testo={t("Refresh")}
              icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
            />
            <CoreButtonHoverIcon
              className="text-blue-700 m-1"
              icon={<AddBoxRoundedIcon className={`fill-blue-700`} />}
              testo={`${t("Operator")}`}
              onClick={() =>
                navigate(`crea-${t("operator")}`, { state: { operator: true } })
              }
            />
            <CoreButtonHoverIcon
              className={"text-darkgray m-1"}
              icon={<DownloadRoundedIcon className="fill-darkgray" />}
              testo="Report"
              onClick={handleDownload}
            />
          </div>
        </div>
      </div>

      <CoreTable
        rows={rows}
        columns={columns}
        button
        actions={actions}
        info={t("Operators")}
        setPage={setPage}
        page={page}
        totalPages={Math.ceil(data?.Data?.count / TABLE_ROWS_NUMBER) || 1}
        isLoading={isLoading || isFetching}
      />
    </>
  );
};

export default GestisciCommercialistiPage;
